import { ModelConfigParams, genericApplicationChecklistMFG, genericApplicationChecklistQC } from "./model-config-params";

export const orthopedic: ModelConfigParams = {
  bodyParts: [
    'artery',
    'vein',
    'bone',
    'nerve',
    'slam',
    'stent',
    'implant',
    'muscleLeftRight',
    'rightPelvis',
    'leftPelvis',
    'cartilage',
  ],
  checklist: genericApplicationChecklistMFG,
  checklistQC: genericApplicationChecklistQC,
  defaultIntensityRange: [0, 3000],
  internal: true,
}
